import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// Modules
import { AtlasModule } from './modules/atlas.module';
import { MaterialModule } from './modules/material.module';

// Constants
import { PRISM_LANGUAGES, languages } from './constants/prism-languages.constants';

// Components
import { ApiDescriptionComponent } from './components/api-description/api-description.component';
import { CodeBlockComponent } from './components/code-block/code-block.component';
import { ContentComponent } from './components/content/content.component';
import { DevicesComponent } from './components/devices/devices.component';
import { ExampleViewerComponent } from './components/example-viewer/example-viewer.component';
import { OverviewComponent } from './components/overview/overview.component';
import { PageTabsComponent } from './components/page-tabs/page-tabs.component';
import { SpecVariationsComponent } from './components/spec-variations/spec-variations.component';
import { TableComponent } from './components/table/table.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { InformationNoteComponent } from './components/information-note/information-note.component';

// Directive
import { ScrollSpyDirective } from './directives/scroll-spy.directive';
import { BodyDirective, TitleDirective, ImgDirective, HeadlineDirective } from './directives/content/content.directive';
import { RightSideNavDirective } from './directives/right-side-nav/right-side-nav.directive';
import { SpecLabelDirective, SpecValueDirective } from './directives/spec/spec.directive';

// Pipes
import { HyphenatePipe } from './pipes/hyphenate';
import { PageSectionComponent } from './components/page-section/page-section.component';
import { SpecComponent } from './components/spec/spec.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ColorSwatchComponent } from './components/color-swatch/color-swatch.component';
import { PageSectionContainerComponent } from './components/page-section-container/page-section-container.component';
import { PageTabsContainerComponent } from './components/page-tabs-container/page-tabs-container.component';
import { RouterModule } from '@angular/router';
import { MarkupComponent } from './components/markup/markup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AtlasModule,
    ScrollingModule,
    RouterModule
  ],
  declarations: [
    OverviewComponent,
    SpecVariationsComponent,
    DevicesComponent,
    CodeBlockComponent,
    ExampleViewerComponent,
    TabsComponent,
    ApiDescriptionComponent,
    HyphenatePipe,
    ScrollSpyDirective,
    PageTabsComponent,
    ContentComponent,
    PageSectionComponent,
    BodyDirective,
    TitleDirective,
    ImgDirective,
    HeadlineDirective,
    SpecComponent,
    SpecLabelDirective,
    SpecValueDirective,
    TableComponent,
    RightSideNavDirective,
    ColorSwatchComponent,
    PageSectionContainerComponent,
    PageTabsContainerComponent,
    MarkupComponent,
    InformationNoteComponent,
  ],
  providers: [
    {
      provide: PRISM_LANGUAGES,
      useValue: languages
    },
    HyphenatePipe
  ],
  exports: [
    AtlasModule,
    MaterialModule,
    CodeBlockComponent,
    CommonModule,
    ExampleViewerComponent,
    FormsModule,
    ReactiveFormsModule,
    OverviewComponent,
    SpecVariationsComponent,
    DevicesComponent,
    TabsComponent,
    ApiDescriptionComponent,
    HyphenatePipe,
    ScrollSpyDirective,
    PageTabsComponent,
    ContentComponent,
    PageSectionComponent,
    BodyDirective,
    TitleDirective,
    ImgDirective,
    HeadlineDirective,
    SpecComponent,
    SpecLabelDirective,
    SpecValueDirective,
    TableComponent,
    RightSideNavDirective,
    ColorSwatchComponent,
    PageSectionContainerComponent,
    PageTabsContainerComponent,
    RouterModule,
    MarkupComponent,
    InformationNoteComponent,
  ]
})
export class SharedModule { }
